// Refer to https://glidejs.com/docs/options/
const glideOptions = {
  type: 'carousel',
  dragThreshold: false,
  focusAt: 0,
  perTouch: 1,
  perView: 1,
};

// When there is a video and less than three media files, there is a bug with the carousel type
// that prevents the video element from being observed, therefore never getting loaded
// The slider type does not have this bug
const glideOptionsAlternate = {
  type: 'slider',
  dragThreshold: false,
  focusAt: 0,
  perTouch: 1,
  perView: 1,
};

const cssClasses = {
  controlsActiveState: 'section-media-gallery-thumbnails__controls--active',
  triggerActiveState: 'section-media-gallery-thumbnails__trigger--active',
};

const mobileSelectors = {
  leftArrowSelector: '[data-media-gallery-mobile-arrow-left]',
  rightArrowSelector: '[data-media-gallery-mobile-arrow-right]',
  sliderSelector: '[data-media-gallery-mobile]',
  slideSelector: '[data-media-gallery-mobile-slide]',
};

const modalSliderSelectors = {
  buttonSelector: '[data-photo-button]',
  leftArrowSelector: '[data-media-gallery-slider-arrow-left]',
  modalSelector: '[data-comp-modal]',
  rightArrowSelector: '[data-media-gallery-slider-arrow-right]',
  slideCaptionSelector: '[data-media-gallery-slide-caption]',
  sliderSelector: '[data-media-gallery-modal]',
  slideSelector: '[data-media-gallery-slider-slide]',
  triggerSelector: '[data-media-gallery-modal-trigger]',
};

const thumbnailSelectors = {
  controlsSelector: '[data-media-gallery-slider-thumbnails-controls]',
  leftArrowSelector: '[data-media-gallery-slider-thumbnails-arrow-left]',
  rightArrowSelector: '[data-media-gallery-slider-thumbnails-arrow-right]',
  sliderSelector: '[data-media-gallery-slider-thumbnails]',
};

const GALLERY_MODAL_ID = 'gallery-modal';

export {
  cssClasses,
  glideOptions,
  glideOptionsAlternate,
  mobileSelectors,
  modalSliderSelectors,
  GALLERY_MODAL_ID,
  thumbnailSelectors,
};
